/*** IMPORTS FROM imports-loader ***/
var _ = require("tpl-shim/fake-lodash.js");

export default function(data) {
var __t, __p = '';
__p += '<div class="modal-header">\n  <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>\n  <h2>Add Media</h2>\n</div>\n<div class="modal-body">\n  <div class="youtubeUploader">\n    <div class="zfLabel">\n      Insert YouTube link:\n    </div>\n    <textarea class="youtubeLinkInput"></textarea>\n    <div class="uploadMessageArea"></div>\n    <div class="submitYoutubeVideo">\n      Submit\n    </div>\n    <div class="previewYoutubeVideo">\n      Preview\n    </div>\n    <div class="cancel-button" data-dismiss="modal" aria-hidden="true">\n      Cancel\n    </div>\n  </div>\n</div>';
return __p
}
